import React from 'react';
import '../styles.css';

const StatsSection: React.FC = () => {
  return (
    <section className='stats-section'>
      <div className='stats-container'>
        <div className='stats-grid'>
          <div className='stat-item'>
            <div className='stat-value'>1.8M+</div>
            <div className='stat-label'>Resources</div>
          </div>
          <div className='stat-item'>
            <div className='stat-value'>1,100+</div>
            <div className='stat-label'>Sponsors</div>
          </div>
          <div className='stat-item'>
            <div className='stat-value'>230,000+</div>
            <div className='stat-label'>Research Projects</div>
          </div>
          <div className='stat-item'>
            <div className='stat-value'>85</div>
            <div className='stat-label'>Research Partners</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
